const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/api/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
interface ApiSettingsSearch {
  type?: string;
}
export const Route = createFileRoute("/_protected/_settingsLayout/settings/api")({
  validateSearch: (search: Record<string, unknown>): ApiSettingsSearch => ({
    type: search?.type as string || undefined
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});